import React from "react";
import { useQuery } from "@tanstack/react-query";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "@/elements/components/utils/convex-api";
import Loader from "@/elements/components/shared/loader";
import TutorChat from "@/elements/components/chat/tutor-chat";
import ParentChat from "@/elements/components/chat/parent-chat";

function Chat() {
  const { data: currentUser, isLoading } = useQuery(
    convexQuery(api.account.queries.getCurrentUser, {})
  );

  if (isLoading || !currentUser) {
    return <Loader />;
  }

  const isTutor = currentUser.persona === "tutor";
  const isParent = currentUser.persona === "parent";

  if (isTutor) {
    return <TutorChat />;
  }

  if (isParent) {
    return <ParentChat />;
  }

  return <Loader />;
}

export default Chat;
